import React from 'react';
import { CheckCircle2, Lock, Star } from 'lucide-react';
export function HeroContent() {
  return <div className="lg:col-span-7 xl:col-span-6 anim-fade-up" data-id="element-1557">
      <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-white border border-blue-100 shadow-sm mb-3" data-id="element-1558">
        <span className="flex h-2 w-2 rounded-full bg-primary animate-pulse" data-id="element-1559"></span>
        <span className="text-xs md:text-sm font-semibold text-navy-900" data-id="element-1560">
          Free In-Home Shower Glass Quotes Available
        </span>
      </div>

      <div className="flex flex-wrap items-center gap-x-3 gap-y-1.5 mb-4" aria-label="5-star reviews and trust indicators" data-id="element-1561">
        <div className="inline-flex items-center gap-2 bg-white border border-gray-200 shadow-sm rounded-full px-3 py-1.5" data-id="element-1562">
          <span className="flex" aria-hidden="true" data-id="element-1563">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-amber-400 text-amber-400" data-id="element-1564" />)}
          </span>
          <span className="sr-only" data-id="element-1565">5-star rated.</span>
          <span className="text-xs font-semibold text-navy-900" data-id="element-1566">
            Trusted by Southeast Michigan Homeowners
          </span>
        </div>
        <span className="hidden sm:inline text-gray-300" aria-hidden="true" data-id="element-1567">
          •
        </span>
        <span className="text-xs font-medium text-gray-600" data-id="element-1568">
          Custom Shower Glass Since 2000
        </span>
        <span className="hidden md:inline text-gray-300" aria-hidden="true" data-id="element-1569">
          •
        </span>
        <span className="hidden md:inline text-xs font-medium text-gray-600" data-id="element-1570">
          Free In-Home Quotes
        </span>
      </div>

      <h1 className="text-2xl md:text-3xl lg:text-4xl xl:text-[2.6rem] font-bold text-navy-900 leading-[1.1] mb-3 tracking-tight" data-id="element-1571">
        Custom Glass Shower Doors &{' '}
        <span className="text-primary" data-id="element-1572">Frameless Shower Enclosures</span> in
        Southeast Michigan
      </h1>

      <p className="text-sm lg:text-base text-gray-600 mb-4 leading-relaxed max-w-2xl" data-id="element-1573">
        Upgrade your bathroom with custom glass shower doors designed, measured,
        fabricated and installed by Kosin's Glass. Choose from frameless, Euro,
        semi-frameless, framed, sliding and tub enclosure options with premium
        glass, quality hardware and professional installation.
      </p>

      <ul className="space-y-2 mb-4" data-id="element-1574">
        {['Custom measured and fabricated for your exact shower or tub opening', 'Frameless, Euro, semi-frameless, framed, sliding and walk-in shower glass options', '18 glass designs and textures plus multiple hardware finishes, colors and styles', 'Free in-home quote, professional installation and lifetime installation guarantee'].map((bullet, i) => <li key={i} className="flex items-start gap-2.5 anim-slide-in-left-sm" style={{
        animationDelay: `${0.2 + i * 0.1}s`
      }} data-id="element-1575">
            <CheckCircle2 className="w-4 h-4 lg:w-5 lg:h-5 text-primary shrink-0 mt-0.5" data-id="element-1576" />
            <span className="text-sm text-gray-700 font-medium leading-snug" data-id="element-1577">
              {bullet}
            </span>
          </li>)}
      </ul>

      <div className="flex items-center gap-2 text-xs text-gray-500 bg-gray-50 inline-flex px-3 py-1.5 rounded-lg border border-gray-100 anim-fade-up" style={{
      animationDelay: '0.6s'
    }} data-id="element-1578">
        <Lock className="w-3.5 h-3.5 text-gray-400" data-id="element-1579" />
        <span data-id="element-1580">
          Your information is secure. Kosin's Glass will never share your
          details.
        </span>
      </div>
    </div>;
}